document.addEventListener("DOMContentLoaded", () => {
  const dropdowns = document.querySelectorAll(".dropdown");

  function closeAllDropdowns() {
    dropdowns.forEach(dropdown => {
      dropdown.classList.remove("active");
    });

    // Remove the "red-border" class when closing dropdowns
    const activePath = document.querySelector(".navbar__item.active-path");
    if (activePath) {
      activePath.classList.remove("red-border");
    }
  }

  dropdowns.forEach(dropdown => {
    const dropbtn = dropdown.querySelector(".dropbtn");
    dropbtn.addEventListener("click", (event) => {
      event.preventDefault();
      const isActive = dropdown.classList.contains("active");
      closeAllDropdowns();

      if (!isActive) {
        dropdown.classList.add("active");
        // Add the "red-border" class when a dropdown is clicked
        const activePath = document.querySelector(".navbar__item.active-path");
        if (activePath && !dropdown.classList.contains("active-path")) {
          activePath.classList.add("red-border");
        }
      } else {
        // Remove the "red-border" class when a dropdown with the active class is clicked again
        const activePath = document.querySelector(".navbar__item.active-path");
        if (activePath) {
          activePath.classList.remove("red-border");
        }
      }
    });
  });

  const hamburger = document.querySelector(".hamburger");
  const header = document.getElementById("header");

  hamburger.addEventListener("click", () => {
    header.classList.toggle("menu-open");
    hamburger.classList.toggle("active");
    closeAllDropdowns();

    if (header.classList.contains("menu-open")) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "visible";
    }
  });

  window.addEventListener("click", event => {
    if (!event.target.matches(".dropbtn") && !event.target.closest(".dropdown-content")) {
      closeAllDropdowns();
    }
  });
});
